import React from 'react';

import PropTypes from 'prop-types';

import { MarkdownContent, Typography } from 'wanderu-components';

import styles from './AmenitiesCard.scss';

const propTypes = {
    description: PropTypes.string,
    title: PropTypes.string,
};

const defaultProps = {
    description: '',
    title: '',
};

const AmenitiesCard = (props) => {
    const {
        title,
        description,
    } = props;
    return (
        <>
            <div className={styles.cardBox}>
                <div className={styles.cardLayout}>
                    <Typography variant='h6'>{title}</Typography>
                    <Typography 
                        variant='body2' 
                        component={MarkdownContent}
                    >
                        {description}
                    </Typography>
                </div>
            </div>
        </>
    );
};

AmenitiesCard.propTypes = propTypes;
AmenitiesCard.defaultProps = defaultProps;

export default AmenitiesCard;
